<template>
  <section>
    <ion-card :class="`card-form ${isDense ? 'dense' : ''}`" :style="{ margin: '10px 10px 5px 5px', padding: '5px 10px' }">
      <!-- <ion-card-subtitle v-if="!this.readonly" :style="{margin: '5px 0', color: 'darkgray'}">Formulário:</ion-card-subtitle> -->
      <ion-card-content v-if="!this.readonly" class="editableInputs">
        <form @submit.prevent="validate() && submit()" @reset.prevent="reset" novalidate="true" ref="form" >
          <ion-grid>
            <ion-row>
              <template v-for="(input, index) in editableInputs" :key="index" :style="{position: 'relative'}">
                <ion-col :size="input.type == 'divider' || !computedIsTablet ? '12' : input.mobile ? input.mobile.cols : input.sm || 'auto'"
                    v-show="typeof input.hide == 'function' ? !input.hide({item: formData}) : typeof input.hide == 'string' ? !formData[input.hide] : !input.hide"
                    :class="`${!readonly && auxInputs[input.value] && auxInputs[input.value].validated && !auxInputs[input.value].validated.valid ? 'error' : ''}`"
                    :style="{paddingLeft: '0', paddingRight: '0'}">

                  <ion-item :class="`${input.type == 'divider' ? `divider-box${index > 0 ? '' : ' first'}` : `box ${(!!formData[input.value] ? 'item-has-value' : '')}`} `" 
                    :style="{borderColor: !readonly /*&& computeInputsForValidation*/ && auxInputs[input.value] && auxInputs[input.value].validated && !auxInputs[input.value].validated.valid ? 'red' : ''}" 
                    lines="none">

                    <!-- DIVIDER -->
                    <template v-if="input.type == 'divider'">
                      <span class="span-divider" v-html="input.label"></span>
                    </template>

                    <!-- TEXT FIELD -->
                    <template v-else-if="input.type == 'text-field'">
                      <ion-label position="floating">{{ input.label }}</ion-label>
                      <ion-input 
                        :class="input.value === 'status' ? 'input-status' : 'inherit'"
                        :hint="input.hint" 
                        :type="input.textType" 
                        :disabled="readonly || input.readonly || isDisable(input)"
                        :placeholder="input.placeholder" 
                        v-model="formData[input.value]" 
                        @change="(event) => proccessInput(formData, input, event.target ? event.target.value || '' : '')" />
                    </template>

                    <!-- TEXT AREA -->
                    <template v-else-if="input.type == 'textarea'">
                      <ion-label position="floating">
                        {{ input.label }}
                      </ion-label>
                      <ion-textarea 
                        v-model="formData[input.value]" 
                        :placeholder="input.placeholder" 
                        :disabled="readonly || input.readonly || isDisable(input)" 
                        :rows="input.rows || 10" />
                    </template>

                    <!-- SELECT -->
                    <template v-else-if="input.type == 'select'">
                      <ion-label position="floating">
                        {{input.label}}
                      </ion-label>
                      <ion-select
                        v-model="formData[input.value]"
                        :value="formData[input.value]"
                        :disabled="readonly || input.readonly || isDisable(input)"
                        :placeholder="input.placeholder"
                        multiple="false"
                        :hint="input.hint"
                        @ionChange="(event) => proccessInput(formData, input, event.target ? event.target.value || '' : '')">
                        
                        <template v-for="(item, index) in (typeof input.items == 'string') ? registers[input.items] : (!isAdmin) ? input.itemsNotAdmin || input.items : input.items" :key="index">
                          <ion-select-option :value="getValueSelect({item, input})" >
                          <!-- <ion-select-option :value="item" >  -->
                            <!-- {{ item.text }} -->
                            {{ (typeof input.itemText == 'function') ? input.itemText({item: formData, element: item}) : (!input.itemText ? item.text: input.itemText) }}
                          </ion-select-option>  
                        </template>
                      </ion-select>
                    </template>

                    <!-- AUTOCOMPLETE -->
                    <template v-else-if="input.type == 'autocomplete'">
                      <SimpleAutoComplete
                        v-model="formData[input.value]" 
                        :disabled="readonly || input.readonly || isDisable(input)"
                        :label="input.label"
                        :delay="'750'"
                        :itemText="input.itemText"
                        :value="input.value"
                        :placeholder="input.placeholder" 
                        :dense="isDense"
                        :options="getItems({input, offline})"
                        @change="(value) => proccessInput(formData, input, value)" />
                    </template>

                    <!-- CUSTOMAUTOCOMPLETE -->
                    <template v-else-if="input.type == 'customautocomplete'">
                      <v-custom-autocomplete
                        v-show="!input.hide"
                        v-model="formData[input.value]"
                        @click:clear="autocompleteHits[input.value] = []"
                         :index="input.value"
                        :value="input.value"
                        :options="autocompleteHits[input.value]" 
                        :loading="autocompleteLoading[input.value]"
                        :filter="(item, queryText, itemText) => input.fieldsToShow.some(x => item[x].toLowerCase().includes(queryText.toLowerCase()))"
                        :handler="handlerAutocomplete"
                        :handlerLoading="handlerAutocompleteLoading"
                        :delay="750"
                        :dependents="input.dependents"
                        :asyncSearch="input.asyncSearch"
                        :fieldsToShow="input.fieldsToShow"
                        :fieldsToSearch="input.fieldsToSearch"
                        :item="formData"
                        :rules="input.rules"
                        :label="input.label"
                        :return-object="input.returnObject"
                        :item-value="input.itemValue"
                        :item-text="input.itemText"
                        :chips="input.chips"
                        :placeholder="input.placeholder"
                        :hint="input.hint"
                        :persistent-hint="input.persistentHint"
                        :small-chips="input.smallChips"
                        :deletableChips="input.deletableChips"
                        :multiple="input.multiple"
                        :disabled="isDisable(input)"
                        :filled="input.filled || isDisable(input)"
                        :dense="isDense"
                        :loadMore="true"
                        :readonly="readonly || input.readonly"
                        :clearable="!readonly && !input.readonly"
                        @change="(value) => proccessInput(formData, input, value)"
                      >
                      </v-custom-autocomplete>
                    </template>

                    <!-- AUTOCOMPLETE ALGOLIA -->
                    <template v-else-if="input.type === 'autocompletealgolia'">
                      <SimpleAutoComplete
                        v-model="formData[input.value]" 
                        :disabled="readonly || input.readonly || isDisable(input)"
                        v-if="offline"
                        :disabledObject="{ params: {input, formData: {...formData}, readonly}, 'execDisable': ({input, formData}) => readonly || input.readonly || isDisable(input) }"
                        :label="input.label"
                        :delay="'750'"
                        :itemText="input.itemText"
                        :value="input.value"
                        :attributesToHighlight="input.fieldsToShow" 
                        :placeholder="input.placeholder" 
                        :options="getItems({input, offline})"
                        @change="(value) => proccessInput(formData, input, value)" />
                      <AutoCompleteAlgolia 
                        v-else
                        v-show="!input.hide" 
                        v-model="formData[input.value]" 
                        :disabled="readonly || input.readonly || isDisable(input)"
                        :modelForm="{...formData[input.value]}" 
                        :disabledObject="{ params: {input, formData: {...formData}, readonly}, 'execDisable': ({input, formData}) => readonly || input.readonly || isDisable(input) }"
                        :index="input.value"
                        :filters="input.filters || []"
                        :value="input.value" 
                        :placeholder="input.placeholder" 
                        :label="input.label" 
                        :options="computedAlgoliaHits[input.value]" 
                        :optionsKey="input.itemText" 
                        :delay="750" 
                        :handler="handlerAlgolia" 
                        :attributesToHighlight="input.fieldsToShow" 
                        :restrictSearchableAttributes="input.fieldsToSearch" 
                        @changed="(value) => proccessInput(formData, input, value)"> 
                      </AutoCompleteAlgolia>
                    </template>

                    <!-- SWITCH -->
                    <template v-else-if="input.type == 'switch' && input.parent && formData[input.parent]">
                      <ion-label>{{ input.label }}</ion-label>
                      <ion-toggle 
                        :disabled="readonly || input.readonly || isDisable(input)"
                        v-model="formData[input.parent][input.value]" />
                    </template>
                    <template v-else-if="input.type == 'switch'">
                      <ion-label>{{ input.label }}</ion-label>
                      <ion-toggle 
                        :disabled="readonly || input.readonly || isDisable(input)"
                        v-model="formData[input.value]" />
                    </template>

                    <!-- Date Picker -->
                    <template v-else-if="input.type === 'date-picker'" >
                      <section class="data-picker">
                        <ion-label position="floating" :style="{margin: '-20px 0 40px', fontSize: '14px'}">{{ input.label }}</ion-label>
                        <ion-datetime-button :datetime="`datetime-${input.value}`" :style="{margin: '0 0 10px'}"></ion-datetime-button>
                        <ion-modal :keep-contents-mounted="true" :ref="`datetime-${input.value}`">
                          <ion-datetime 
                            :id="`datetime-${input.value}`"
                            locale="pt-BR"
                            v-model="formData[input.value]"
                            :disabled="readonly || input.readonly || isDisable(input)"
                            :value="auxData[input.value]['modelFormated']"
                            displayFormat="DD/MM/YYYY"
                            presentation="date"
                            max="2099-12-31"
                            :style="{textColor: 'white'}"
                            clear-text="Limpar"
                            @ionChange="formatDatePickerTextField($event.target.value, input);proccessInput(formData, input, $event.target.value);modalDismiss(`datetime-${input.value}`)">
                          </ion-datetime>
                        </ion-modal>
                      </section>
                    </template>
                  </ion-item>

                  <template v-if="!readonly && auxInputs[input.value] && auxInputs[input.value].validated && auxInputs[input.value].validated.message">
                    <ion-label :style="{color: 'red'}">
                      {{auxInputs[input.value].validated.message}}
                    </ion-label>
                  </template>
                </ion-col>
              </template>
            </ion-row>
          </ion-grid>
        </form>
      </ion-card-content>
     
      <!-- <ion-card-subtitle :style="{margin: '10px 0 0px', color: 'darkgray', fontSize: '1.2em'}">Detalhes do pedido</ion-card-subtitle> -->
      <ion-card-header 
      v-if="this.companySelected.groupCompany == 'decanter' && !readonly" 
      @click="openReadonlyInputs = !openReadonlyInputs"
      :style="{ padding: '10px 2px 5px' }">
          <ion-list class="ion-no-padding ion-no-margin">
            <ion-item lines="none" class="ion-no-padding ion-no-margin">
              <ion-card-subtitle :style="{fontSize: '0.65em', margin: '0'}"> Detalhes do pedido </ion-card-subtitle>
              <ion-icon :size="isDense ? 'small': 'default'" :icon="(item.show) ? chevronUp : chevronDown"></ion-icon>
            </ion-item>
          </ion-list>
      </ion-card-header>

      <ion-card-content v-show="this.companySelected.groupCompany != 'decanter' || openReadonlyInputs || readonly" class="readonlyInputs">
        <ion-list>
          <ion-item v-for="(input, index) in readonlyInputs" :key="index" class="ion-no-padding">
            <ion-label :style="{ margin: '0' }">
              <h6 :style="{color: 'gray'}">{{input.label}}:</h6>
              <p v-if="input.fieldsToShow && input.fieldsToShow.length > 0 && formData[input.value]" :style="{color: isDark ? 'white' : 'black'}">
                <template v-for="(field, ix) in input.fieldsToShow" :key="field">
                  <span v-if="ix > 0" class="mx-1"> - </span>
                  <span v-html="formData[input.value][field]"/>
                </template>
              </p>
              <p v-else-if="input.itemText && formData[input.value]" :style="{color: isDark ? 'white' : 'black'}">{{ (typeof input.itemText == 'function') ? input.itemText({item: formData, element: formData[input.value]}) : formData[input.value][input.itemText]}}</p>
              <p v-else :style="{color: isDark ? 'white' : 'black'}">{{ getFormatValue(input, formData) }}</p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </section>
</template>

<script>
  // import VJsf from '@koumoul/vjsf'
  // import VAutocompleteAlgolia from '../VAutocompleteAlgolia.vue'
  // import { reactive } from 'vue'
  import {createNamespacedHelpers, mapMutations, mapState} from "vuex";
  import useAutoComplete from '../../useAutoComplete'
  import SimpleAutoComplete from "../SimpleAutoComplete.vue";
  import AutoCompleteAlgolia from "../AutoCompleteAlgolia.vue";
  import VCustomAutocomplete from "../VCustomAutocomplete.vue";
  import store from "../../store";
  import {  
    chevronDown, 
    chevronUp, 
  } from "ionicons/icons";
  import {
    IonInput,
    IonList,
    IonItem,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonIcon,
    // IonText,
    IonDatetime,
    IonDatetimeButton,
    IonModal,
    IonLabel,
    IonTextarea,
    IonSelectOption,
    IonSelect,
    IonToggle,
    IonGrid,
    IonRow,
    IonCol
  } from "@ionic/vue";
  const {mapState: registersState, mapActions: registersActions, mapMutations: registersMutations} = createNamespacedHelpers("registers");
  const {mapState: authState, mapActions: authActions} = createNamespacedHelpers("auth");
  export default {
    name: "Form",
    // emits: ['onValidated'],
    components: {
      IonInput,
      IonList,
      IonItem,
      IonCard,
      IonCardContent,
      IonCardHeader,
      IonCardSubtitle,
      IonLabel,
      IonDatetime,
      IonDatetimeButton,
      IonModal,
      IonIcon,
      IonTextarea,
      IonSelectOption,
      IonSelect,
      IonToggle,
      IonGrid,
      IonRow,
      IonCol,
      SimpleAutoComplete,
      AutoCompleteAlgolia,
      VCustomAutocomplete
    },
    props: {
      props: Object,
      inputs: {
        type: Array,
        default: () => [],
      },
      color: {
        type: String,
        default: "teal",
      },
      dark: {
        type: Boolean,
        default: false,
      },
      model: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      collection: {
        required: false,
        type: String,
      },
      collectionDetails: {
        required: false,
        type: String,
      },
      readonly: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        /**
         * Guarda o conteúdo (`String`) de cada input on the fly através do v-bind
         */
        openReadonlyInputs: false,
        formData: {},
        options: [
          { value: '1', text: 'aa' + ' - ' + '1' },
          { value: '2', text: 'ab' + ' - ' + '2' },
          { value: '3', text: 'bc' + ' - ' + '3' },
          { value: '4', text: 'cd' + ' - ' + '4' },
          { value: '5', text: 'de' + ' - ' + '5' }
        ],
        item: {
          value: '',
          text: ''
        },

        /**
         * Guarda os valores de dados auxiliares de cada input.
         */
        auxData: {},

        /**
         *
         */
        querySelection: null,
        formChips: 4,
        searchAlgolia: "",
        algoliaHits: [],
        auxInputs: [],
        autocompleteHits: {},
        autocompleteLoading: {},
        ultPedidoCliente: {}
      };
    },
    computed: {
      ...registersState(["registers", "counters"]),
      ...authState(["user"]),
      ...mapState(["searching", "offline", "companySelected"]),

      isAdmin() {
        return this.user && (
          this.user.superAdmin ||
          this.user.isAdminCompanySelected
        )
      },

      isDense() { return this.props.formDense },
      isDark() { return store.$isDark },
      
      editableInputs() {
        let inputs = this.inputs.filter(x => x.value && x.hide != true && x.disabled != true)
        return inputs
      },
      
      readonlyInputs() {
        let inputs = this.inputs.filter(x => x.value && x.hide != true && (x.disabled == true || this.readonly))
        return inputs
      },

      itemsForAutocomplete(input) {
        return typeof input.items == "string" ? registers[input.items] : Array.isArray(input.items) ? input.items : auxData[input.value].items;
      },

      computedIsTablet() {
        // landscape-primary
        // portrait-primary
        return window.screen.availWidth > 500 && window.screen?.orientation?.type.includes("landscape")
      },

      // computeInputsForValidation(){
      //   this.inputs.map(input => {
      //     if(input.rules) {
      //       this.auxInputs[input.value] = {...input, validated:{valid: false, message: ''}}
      //     }
      //   });

      //   return true;
      // },

      computedAlgoliaHits() {
        return this.algoliaHits;
      },
      computedOffline() {
        return this.offline
      }
    },

    watch: {
      model: {
        handler: function(newValue) {
          this.setFormData(newValue);
        },
      },
      user: {
        handler: function(newValue) {
          this.getUser(newValue);
        },
      },
      inputs: {
        handler: function() {
          this.setFormData(this.model);
        },
      }/*,
      auxData: {
        handler: function() {
          this.setFormData(this.model);
        },
      },*/
    },

    methods: {
      ...registersActions(["setLoadedForm", "save", "getDetails", "get", "getApi", "getById", "getOffline"]),
      ...registersMutations(["setRegister"]),
      ...authActions(["getSA3Subs"]),
      ...mapMutations(["setLoading"]),

      isDisable(input){
        const result = typeof input?.disabled == 'string' ? 
          this.formData[input.disabled] : typeof input?.disabled == 'function' ? 
          input.disabled({item: this.formData, input: input, user: this.user,  claimRoute: this.claimRouteMethod()}) : input?.disabled
        return result || false
      },

      // ultPedidoSE4({item}) {
      //   setTimeout(() => {
      //     if (
      //       item.C5_CLIENTE 
      //       && item.C5_LOJACLI 
      //       && this.ultPedidoCliente.C5_CLIENTE != item.C5_CLIENTE 
      //       && this.ultPedidoCliente.C5_LOJACLI != item.C5_LOJACLI
      //     ) {
      //       this.ultPedidoCliente = {
      //         C5_CLIENTE: item.C5_CLIENTE,
      //         C5_LOJACLI: item.C5_LOJACLI 
      //       }
      //       this.get({
      //         collection: 'SC5', 
      //         filters: [
      //           {key: "C5_CLIENTE", operator: '==', value: item.C5_CLIENTE},
      //           {key: "C5_LOJACLI", operator: '==', value: item.C5_LOJACLI},
      //         ], 
      //         orderBy: [
      //           {key: "lifeControl.createdAt", mod: 'desc'},
      //         ],
      //         limit: 1,
      //         forceOrder: true,
      //         disableIntFilters: !!(this.user.superAdmin || this.user.companies[this.companySelected.groupCompany].admin),
      //         forceFilter: true,
      //         setRegister: false
      //       })
      //       .then(SC5 => {
      //         if(SC5 && SC5[0] && SC5[0].C5_CONDPAG) { 
      //           const C5_CONDPAG = SC5[0].C5_CONDPAG 
      //           this.getById({
      //             collection: 'SE4', 
      //             id: C5_CONDPAG
      //           }).then(SE4 => {
      //             if (SE4 && SE4.id) {
      //               this.formData.SE4 = {} 
      //               this.formData.C5_CONDPAG = C5_CONDPAG
      //             }
      //           })
      //         }
      //       })
      //     }
      //   }, 100);
      // },

      getValueSelect({item, input}){

        // if (input.value === 'SE4') {
        // }
        if (input.itemValue) {
          return item[input.itemValue]
        }

        return item.value ? item.value : item
      },

      getItems({input, algolia = false, offline = false}) {
        let items = []
        if (offline) {
          if (this.auxData[input.value] && this.auxData[input.value].items) {
            items = this.auxData[input.value].items
          } else if (input.itemsOffline && input.itemsOffline.localStorageCache) {
            const { collection, filtersOffline } = input.itemsOffline
            const { name:nameFilter } = filtersOffline
            const itemsStoraged = JSON.parse(localStorage.getItem(`offline:customers/${this.companySelected.groupCompany}/${collection}${nameFilter ? `_${nameFilter}` : ''}`))
            items = itemsStoraged ? Object.keys(itemsStoraged).map((key, index) => itemsStoraged[key]) : []
          }
        } else if (algolia) {
          return this.computedAlgoliaHits[input.value];
        } else {
          items = typeof input.items === "string" ? this.registers[input.items] : Array.isArray(input.items) ? input.items : this.auxData[input.value].items;
        }
        return items
      },

      async computeHide(item, input) {
        const self = {
          getById: this.getById,
          get: this.get,
          // getSA3Subs: this.getSA3Subs,
          item,
          input,
          user: this.user,
          registers: this.registers,
        };

        let show = true;

        if (typeof input.hide == "function") {
          show = !(await input.hide(self));
        } else if (typeof input.hide == "string") {
          show = !this.formData[input.hide];
        } else if (typeof input.hide == "boolean") {
          show = !input.hide;
        }

        // this.$set(input, 'show', show)
        input["show"] = show;

        return show;
      },

      claimRouteMethod(){
        return store.$route?.meta.claimRoute == 'edit' ? true : false
      },

      submit(event) {
        this.$emit("submit", this.getModel());
      },

      validate(submitToErp = false) {
        const inputs = this.inputs.filter(x => x.rules || x.rulesOnSketch)
        for (const input of inputs) {
          this.validateInput(input, this.formData[input.value], submitToErp)
        }
      
        const validations = Object.values(this.auxInputs).map(x => x.validated).map(x => x.valid)
       
        return validations.every(x => x)
      },

      validateInput(input, value, submitToErp = true){
        if(input.rules){
          input.rules.forEach(rule => { 
            const fn = (item) => eval(rule)(value)
            let response = fn(this.formData)
            if (!this.auxInputs[input.value]) this.auxInputs[input.value] = {}
            if (!this.auxInputs[input.value].validated) this.auxInputs[input.value].validated = {}
            this.auxInputs[input.value].validated.valid = (typeof response === 'boolean') ? response : false
            this.auxInputs[input.value].validated.message = (typeof response === 'string') ? response : ''
          })
        }
        if (!submitToErp && input.rulesOnSketch) {
          input.rulesOnSketch.forEach(rule => { 
            const fn = (item) => eval(rule)(value)
            let response = fn(this.formData)
            if (!this.auxInputs[input.value]) this.auxInputs[input.value] = {}
            if (!this.auxInputs[input.value].validated) this.auxInputs[input.value].validated = {}
            this.auxInputs[input.value].validated.valid = (typeof response === 'boolean') ? response : false
            this.auxInputs[input.value].validated.message = (typeof response === 'string') ? response : ''
          })
        }
      },
     
      proccessInput(item, input, value) {
        this.validateInput(input, value)
        this.setValue(item, input, value);
        this.proccessDependencies(item, input);
        this.computeHide(item, input);
      },

      getFormatValue(header, item) {
        if (!item) return
        let value = item[header.value]
        if (typeof value === 'undefined' || value === null) { return }

        const prefix = header.prefix
          ? header.prefix + ' '
          : ''

        let maskedValue
        if (header.money) {
          if (typeof value == 'string') value = parseFloat(value)
          maskedValue =
            "R$ " +
            value.toLocaleString("pt-br", {
              minimumFractionDigits: header.precisionText || 2,
              maximumFractionDigits: header.precisionText || 2,
            });
        } else {
          maskedValue = header.type == 'float' || header.type == 'integer'
            ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText || 2, maximumFractionDigits: header.precisionText || 2 })
            : value
        }
          
        const suffix = header.suffix
          ? ' ' + header.suffix
          : ''

        return prefix + maskedValue + suffix
      },

      getModel() {
        const formData = store.$_.cloneDeep(this.formData);

        // Filtra os inputs que estão com a flag send = false
        this.inputs
          .filter((input) => (typeof input.send == "function" ? !input.send(formData) : "send" in input && !input.send))
          .map((input) => input.value)
          .forEach((value) => delete formData[value]);

        const jsfInputs = this.inputs
          .filter((input) => input.type == "jsf" && input.root == true)
          .reduce((acc, input) => {
            const inputData = formData[input.value];
            delete formData[input.value];
            return {
              ...acc,
              ...inputData,
            };
          }, {});

        /**
         * Transforma os atributos com chaves compostas (ex.: 'a.b.c': 1) em objetos aninhados (ex.: a: { b: { c: 1 } } ).
         */
        const entries = Object.entries(formData);
        const [keys, vals] = entries.reduce(
          ([accKeys, accVals], [key, val]) => [
            [...accKeys, key],
            [...accVals, val],
          ],
          [[], []]
        );
        const formDataDeep = store.$_.zipObjectDeep(keys, vals);

        return {...formDataDeep, ...jsfInputs};
      },

      async setFormData(model) {
        /**
         * Possível generalização de condição de haver um dado auxiliar + caracteristicas do dado a ser criado + valor default.
         */
        this.inputs
          .filter((input) => input.type === "autocomplete")
          .forEach((input) => {
            if (input.computed) {
              this.computeValue(model, input);
            }

            if (input.value in this.auxData) {
              this.auxData[input.value] = {...this.auxData[input.value], loadingAutocomplete: false, searchAutocomplete: null};
              // this.auxData[input.value]["searchAutocomplete"] = null;
            } else {
              // this.$set(this.auxData, input.value, { loadingAutocomplete: false, searchAutocomplete: null })
              this.auxData[input.value] = {loadingAutocomplete: false, searchAutocomplete: null};
            }
          });

        this.inputs
          .filter((input) => "select#switch#text-field".includes(input.type) && input.computed)
          .map((input) => {
            
            // const valueInput = eval(input.default)
            // this.computeValue(model, input)
          });

        this.inputs
          .filter((input) => input.type === "password")
          .forEach((input) => {
            if (input.value in this.auxData) {
              this.auxData[input.value]["showPassword"] = false;
            } else {
              // this.$set(this.auxData, input.value, { showPassword: false })
              this.auxData[input.value] = {showPassword: false};
            }
          });

        // this.inputs.filter(input => typeof input.hide === 'string').map(input => input.hide = eval(input.hide))validatedvalidated

        /**
         * Atribui um valor inicial para cada input de acordo com a propriedade correspondente em this.model.
         * A forma de atribuir o valor varia de acordo com o tipo do input.
         */
        await Promise.all(
          this.inputs.map(async (input) => {
            switch (input.type) {
              case "text-field":
              case "password":
              case "textarea":
              case "switch":
              case "select": 
              // {
              //   const value = model[input.value] ? model[input.value] : "default" in input ? input.default : "";

              //   this.formData = {...this.formData, [input.value]: value}

              //   break;
              // }
              case "combobox":
              case "file": {
                let value = model[input.value] ? model[input.value] : "default" in input ? input.default : "";

                if (input.date && !(value instanceof Date) && !isNaN(value) && typeof value != "string") {
                  value = store.$moment(value.toDate()).format("DD/MM/YYYY");
                }
                if (input.dateHour && !(value instanceof Date) && !isNaN(value) && typeof value != "string") {
                  value = store.$moment(value.toDate()).format("DD/MM/YYYY - HH:mm:ss");
                }
                if (input.dateYear && !(value instanceof Date) && !isNaN(value) && typeof value != "string") {
                  value = store.$moment(value.toDate()).format("YYYY");
                }
                if (input.datePlusWeek && !(value instanceof Date) && !isNaN(value) && typeof value != "string") {
                  value = store.$moment(value.toDate()).format("DD/MM/YYYY, dddd");
                }
                // this.$set(this.formData, input.value, value)
                this.formData[input.value] = value;
                break;
              }

              case "autocomplete": {
                await this.loadItems({input, model})
                break
              }
            
              case "date-picker": {
                this.auxData[input.value] = {menu: false, modelFormated: ''}
                let value = model[input.value] ? model[input.value] : "default" in input ? input.default : "";
                if (!value) break
                this.formatDatePickerTextField(value, input)
                break;
              }

              case "customautocomplete": {
                const value = model[input.value] ? model[input.value] : "default" in input ? input.default : "";
                this.formData[input.value] = value

                if (value) this.autocompleteHits[input.value] = [value]

                // prop item-text
                if (input.fieldsToShow) {
                  input.itemText = ({element}) => {
                    let str = element[input.fieldsToShow[0]]?.trim();
                    input.fieldsToShow.slice(1).forEach((field) => {
                      str = str + " - " + element[field]?.trim();
                    });

                    return str;
                  };
                }

                break;
              }

              case "autocompletealgolia": {
                const value = model[input.value] ? model[input.value] : "default" in input ? input.default : "";
                // this.$set(this.formData, input.value, value)
                // this.formData[input.value] = value;

                this.formData = {...this.formData, [input.value]: value}
              
                if (value) 
                  this.algoliaHits = {...this.algoliaHits, [input.value]: [value]}
                
                // if (value)
                  // this.$set(this.algoliaHits, input.value, [value])
                  // this.formData[input.value] = [value];

                // prop item-text         //se tiver offline, ele deixa a lógica que será usada no simpleAutoComplete
                if (typeof input.items == "string" && input.returnObject) {
                  this.auxData[input.value] = {
                    ...this.auxData[input.value],
                    items: this.registers[input.items]
                  }
                }
                if (input.fieldsToShow/* && !this.offline*/) {
                  input.itemText = ({element}) => {
                    let str = element[input.fieldsToShow[0]] && element[input.fieldsToShow[0]].trim();
                    input.fieldsToShow.slice(1).forEach((field) => {
                      if (element[field] && typeof element[field] === "string") {
                        str = str + " - " + element[field].trim();
                      }
                    });
                    return str;
                  }
                }

                break;
              }

              case "jsoneditor": {
                // this.$set(this.formData, input.value, model[input.value]? model[input.value] : {})
                this.formData[input.value] = model[input.value] ? model[input.value] : {};
                break;
              }

              case "jsfChild": {
                let _model = [];
                if (model && model[input.value])
                  _model = model[input.value].map((input) => {
                    return {
                      data: input.data || input,
                      delete: false,
                    };
                  });

                // this.$set(this.formData, input.value, _model)
                this.formData[input.value] = _model;

                /**
                 * Ordena os inputs
                 */
                if (input.schema && input.schema.properties) input.schema.properties = this.sortJsfProperties(input.schema.properties);

                let auxData = [];
                for (let m of _model) {
                  auxData.push({
                    schema: input.schema,
                    options: {disableAll: false},
                  });
                }

                // this.$set(this.auxData, input.value, auxData)
                this.auxData[input.value] = auxData;

                break;
              }

              case "jsf": {
                /**
                 * Se é uma string, pega o valor do jsoneditor correspondente,
                 * Se é objeto, usa ele mesmo.
                 */
                const schema = typeof input.schema == "object" ? input.schema : typeof input.schema == "string" ? this.formData[input.schema] : {properties: {}};

                const value = typeof input.schema == "object" ? input.value : input.schema;

                /**
                 * Ordena os inputs
                 */
                this.updateVJSF(schema, {value});

                if (!this.auxData[input.value])
                  // this.$set(this.auxData, input.value, {})
                  this.auxData[input.value] = {};

                /**
                 * @TODO Modelar os atributos na raiz do formData em vez de input.value.
                 * Atualmente a desestruturação só é feita na hora de enviar o form.
                 */
                if (input.root) {
                  const _model = Object.entries(model).reduce((acc, [key, value]) => (key in schema.properties ? {...acc, [key]: value} : acc), {});
                  // this.$set(this.formData, input.value, _model)
                  this.formData[input.value] = _model;
                } else {
                  // this.$set(this.formData, input.value, this.auxData[input.value].model)
                  this.formData[input.value] = this.auxData[input.value].model;
                }

                // this.$set(this.auxData[input.value], 'model', model[this.collectionDetails] || {})
                this.auxData[input.value]["model"] = model[this.collectionDetails] || {};
                break;
              }

              case "color-picker": {
                const value = model[input.value] || "#000000";
                // this.$set(this.formData, input.value, value)
                this.formData[input.value] = value;
                // this.$set(this.auxData, input.value, { menu: false, model: value, errorMessages: [] })
                this.auxData[input.value] = {menu: false, model: value, errorMessages: []};
                break;
              }
            }

            // Executa os v-on change na edição
            if (input.on && input.on.change) {
              input.on.change.forEach((change) => {
                change(this.formData[input.value]);
              });
            } 
          })
        );

        this.inputs.forEach((input) => {
          if (input.computeFirst) this.computeValue(this.formData, input);
          this.computeHide(model, input);
        });

        this.inputs
          .filter(input => input.rules && input.rules.length > 0)
          .forEach(input => {
            this.validateInput(input, this.formData[input.value])
          })
      },

      formatDatePickerTextField(value, input) {
        value = value.substr(0, 10)
        // value = new Date(value+" 00:00")
        // if (input.dateYear && (value instanceof Date)) {
        //   value = store.$moment(value).format("YYYY");
        // }
        // else if (input.datePlusWeek && (value instanceof Date)) {
        //   value = store.$moment(value).format("DD/MM/YYYY, dddd");
        // } else {
        //   value = store.$moment(value).format("DD/MM/YYYY");
        // }
        this.auxData[input.value]['modelFormated'] = value
        this.formData[input.value] = value
      },

      modalDismiss(ref) {
        const modal = this.$refs[ref][0].$el
        modal.dismiss();
      },

      async loadItems({input, model, inputDispatcher}){
        let offlineReference = null
        if (input.type === 'autocomplete') {
          const value = model[input.value] ? model[input.value] : ('default' in input) ? input.default : ""
          this.auxData[input.value] = value;
    
          if (Array.isArray(input.items)) {
            this.auxData[input.value] = { ...this.auxData[input.value], items: input.items }
          } else if (typeof input.items == 'object' && !Array.isArray(input.items)) {
            if (['get', 'getApi', 'getById', 'getSA3Subs'].indexOf(input.items.method) >= 0) {
              const user = {
                uid: this.user.uid,
                displayName: this.user.displayName,
                SA3: this.user.SA3,
                superAdmin: this.user.superAdmin,
              }

              
              try {
                if (inputDispatcher && model[inputDispatcher.value] && model[inputDispatcher.value]['offline']) {
                  offlineReference = { ...inputDispatcher.itemsOffline, id: model[inputDispatcher.value]['id'] }
                }
                if (input.disabled) return // Caso desabilidato não carrega itens para poupar processamento
                const setParams = eval(input.items.params)
                let params = setParams ? setParams({ item: model, user }) : null

                if (params){
                  if (offlineReference) {
                    params[0] = {...params[0], offlineReference}
                  }
                  const method = input.items.method === 'get' && this.offline && offlineReference ? 'getOffline' : input.items.method// 'get'
                  const items = await this[method](...params)

                  this.auxData[input.value] = {
                    ...this.auxData[input.value],
                    items
                  }

                } else {
                  this.auxData[input.value] = {
                    ...this.auxData[input.value],
                    items: []
                  }
                }
              } catch (err) {
                console.error(`Error in input ${input.value}`, err)
              }
            } else {
              console.warn(`input "${input.value}" has invalid object "items" prop value on attribue "method" (items.method = ${input.items.method})`)
            }
    
          } else if (typeof input.items == "string" && input.returnObject) {
            if (input.items.includes('=>')) {
              const items = eval(input.items)({item: model})
              this.auxData[input.value] = { ...this.auxData[input.value], items }
            } 
          } else if (typeof input.items == "function" && input.returnObject) {
            const items = input.items({item: model})
            
            this.auxData[input.value] = { ...this.auxData[input.value], items }
          } else if (value && input.returnObject && typeof input.items == "string") {
            this.setRegister({ register: input.items, data: value })
          }
        }
      },

      clearField({field}) {
        this.formData[field] = null;
      },

      changeColorPickerInput(value, input) {
        this.auxData[input.value].errorMessages.splice(0);
        if (!value) this.formData[input.value] = "#000000";
        else if (!/^#(?:[0-9a-f]{3}){1,2}$/i.test(value)) this.auxData[input.value].errorMessages.push("Formato inválido.");
        else this.formData[input.value] = value;
      },

      querySelections(query, input) {
        if (!query || query == this.auxData[input.value].lastQuerySelection) return;
        else this.auxData[input.value].lastQuerySelection = query;

        if (this.auxData[input.value].querySelection) {
          clearTimeout(this.auxData[input.value].querySelection);
          this.auxData[input.value].querySelection = null;
        }

        const {collection, register, filters, orderBy} = input.search || {};
        this.auxData[input.value].querySelection = setTimeout(async () => {
          this.auxData[input.value].querySelection = null;
          if (!query || !collection || !register || !orderBy) return;

          this.auxData[input.value].loadingAutocomplete = true;
          const response = await this.get({collection, register, orderBy, filters, query});
          this.auxData[input.value].loadingAutocomplete = false;
        }, 500);
      },

      reset() {
        this.inputs.forEach((input) => {
          if (input.type == "jsoneditor") {
            this.formData[input.value] = {};
          }
        });
        this.$refs.form.reset();
      },

      resetValidation() {
        return this.$refs.form.resetValidation();
      },

      updateVJSF(data, input) {
        if (data) {
          if (!this.auxData[input.value])
            this.auxData[input.value] = {};

          if (data.properties) data.properties = this.sortJsfProperties(data.properties);
          else {
            const properties = {};
            for (const el of data) {
              properties[el.value] = store.$_.cloneDeep(el);
              delete properties[el.value].value;
            }
            data = {
              properties,
              type: "object",
            };
          }

          this.auxData[input.value]["schema"] = data;
        }
      },

      sortJsfProperties(properties) {
        if (typeof properties == "object") return Object.fromEntries(Object.entries(store.$_.cloneDeep(properties)).sort(([, a], [, b]) => a.order - b.order));
        else return properties;
      },

      /**
       * Computa os valores dos atributos de `item` que estão presentes em `headers` respeitando a ordem passada
       */
      async computeItem(item, inputs, inputDispatcher) {
        for (const input of inputs) {
          if (input.reloadItems) {
            await this.loadItems({input, model: item, inputDispatcher})
          }
          await this.computeValue(item, input);
          await this.computeHide(item, input);
        }

        // if (this.companySelected.groupCompany == 'decanter') {
        //   await this.ultPedidoSE4({item: this.formData})
        // }

        this.$emit('changeForm', {formData: this.formData})
      },

      /**
       * Computa o atributo `header` no objeto `item`
       */
      async computeValue(item, input) {
        if (this.companySelected.groupCompany == 'portao_cambui' && this.readonly) return
        const self = {
          getById: this.getById,
          getApi: this.getApi,
          get: this.get,
          getSA3Subs: this.getSA3Subs,
          item,
          input,
          user: this.user,
          setLoading: this.setLoading,
          companySelected: this.companySelected,
          readonly: this.readonly
        };

        try {
          const computedValue = input.computed ? await input.computed(self) : item[input.value];

          // console.info('computedValue', input, input.value, computedValue)
          if (
            input.type == 'customautocomplete'
            && computedValue
            && computedValue.id
            && this.autocompleteHits
          ) {
            const registers = this.autocompleteHits[input.value]
            if (registers) {
              const ix = registers.findIndex(x => x.id == computedValue.id)
              if (ix == -1) { this.autocompleteHits[input.value].push(computedValue) }
            } else {
              this.autocompleteHits[input.value] = [computedValue]
            }
          }
    
          this.proccessInput(item, input, computedValue);

          if (input && input.on && input.on.change) { 
            for (const change of input.on.change) {
              change(computedValue) 
            }
          }
    
          return computedValue;
        } catch(e) {
          console.error(`Computed ${input.value}: ${input.computed}`, e);
          return ''
        }
      },

      setValue(item, input, value) {
        const handledValue = input.set ? input.set(value, item) : value;

        item = {...item, [input.value]: handledValue}
        
        this.formData[input.value] = handledValue

        this.$emit("change:" + input.value, handledValue)

        return handledValue;
      },


      async proccessDependencies(item, input) {
        // Os inputs/atributos a serem usados como busca não devem incluir o próprio elemento que está sendo alterado.
        const inputs = this.inputs.filter((h) => h != input);

        // Array com os dependentes diretos do input, elimina a possibilidade do elemento ser dependente *direto* dele mesmo devido ao filter.
        const directDependentAttributes = this.getDependentAttributes(input, inputs);

        // Headers a serem computados respeitando a ordem de precedência da menor posição do array pra maior.
        const dependencyChain = this.getDependencyChain(directDependentAttributes, inputs);

        // for of para respeitar a ordem do array `dependencyChain`.
        for (const dependentAttributes of dependencyChain) {
          await this.computeItem(item, dependentAttributes, input);
          inputs.map(async (i) => await this.computeHide(item, i));
        }
      },

      /**
       * Retorna um array de inputs que dependem *diretamente* do `input` passado no primeiro parâmetro
       */
      getDependentAttributes(input, inputs) {
        return inputs.filter((h) => h.dependents && h.dependents.includes(input.value));
      },

      /**
       * Retorna uma cadeia de inputs que são dependentes dos inputs passados no primeiro argumento.
       * A ordem dos elementos no array indicam o grau de dependência dos inputs.
       */
      getDependencyChain(dependents, inputs, dependencyChain = []) {
        if (dependents.length == 0) return dependencyChain;

        const filteredInputs = inputs.filter((h) => !dependents.includes(h));
        const newDependents = dependents.map((h) => this.getDependentAttributes(h, filteredInputs)).reduce((acc, arr) => [...acc, ...arr.filter((el) => !acc.includes(el))], []);

        return this.getDependencyChain(newDependents, filteredInputs, [...dependencyChain, dependents]);
      },

      getUser(user) {
        // ver isso aqui  depois
        if (!this.readonly) {
          const _user = user
            ? {
                uid: user && user.uid,
                displayName: user.displayName,
                email: user.email,
                SA3: user.SA3,
              }
            : null;

          const input = this.inputs.find((i) => i.value == "_user") || {value: "_user"};
          this.proccessInput(this.formData, input, _user);
        }
      },

      async handlerAlgolia(req) {
        try {
          const {index, hits} = await req;
          this.algoliaHits = {...this.algoliaHits, [index]: hits};
        } catch (err) {
          console.error(err);
        }
      },

      async handlerAutocomplete(req) {
        try {
          const {index, hits, query, notClear = false} = await req;
          if (notClear) {
            this.autocompleteHits[index] = this.autocompleteHits[index].concat(hits);
          } else {
            this.autocompleteHits[index] = hits 
          }
        } catch (err) {
          this.autocompleteHits[index] = [] 
          console.error(err);
        }
      },


      async handlerAutocompleteLoading(index, bool) {
        try {
          this.autocompleteLoading[index] = bool;
        } catch (err) {
          console.error(err);
        }
      },


      selectAll({input, items, itemValue}) {
        const {value} = input;
        this.$nextTick(() => {
          if (items && this.formData[value] && this.formData[value].length >= items.length) {
            this.proccessInput(this.formData, input, []);
          } else if (items) {
            this.proccessInput(this.formData, input, itemValue ? items.map((x) => x[itemValue]).slice() : items.slice());
          }
        });
      },
    },

    setup(props) {
      return {
        chevronDown,
        chevronUp,
        ...useAutoComplete({options: props.options, optionsKey: props.optionsKey}),
      };
    },
    created() {
      this.setFormData(this.model)
      if (![undefined, "users"].includes(this.collection)) this.getUser(this.user);
    },
  };
</script>
<style scoped>
  .card-form {
    margin: 0;
    padding: 10px;
  }
  .card-form ion-card-content {
    margin: 0;
    padding: 0;
  }
  .card-form ion-grid {
    margin: 0;
    padding: 0;
  }
  .box {
    border-color: rgba(0, 0, 0, 0.2);
    border-width: thin;
    border-style: solid;
    border-radius: .5em;
    padding: 5px 0;
    margin-bottom: .01em;
    margin-top: .2em;
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
    font-family: Open Sans,sans-serif!important;
    color: rgba(0, 0, 0, 0.671);
  }
  .divider-box {
    border: 0;
    border-bottom: .1em;
    border-color: grey!important;
    border-style: solid;
    width: 100%;
    margin: 0;
    padding: 0;
    padding-top: 0;
  }

  .divider-box:not(.first) {
    padding-top: .5em;
  }
  .divider-box * {
    font-size: 1.3em;
  }

  ion-datetime {
    padding-left: 0;
  }

  ion-label.label-floating {
    color: grey !important;
  }
  ion-card.dense ion-card-content.readonlyInputs ion-label {
    font-size: 0.85em;
  } 
  ion-card.dense ion-col.error {
    padding-bottom: 0!important;
  } 
  ion-card.dense ion-label, ion-card.dense h6 , ion-card.dense p {
    font-size: 0.9em;
  } 
  ion-card.dense form ion-item {
    --min-height: unset;
    font-size: 0.9em;
    padding: 3px 0;
    margin: 0;
  } 
  ion-card.dense form ion-item ion-label {
    --min-height: unset;
    font-size: 1em;
    margin: 5px 0 -5px 0!important;
    -webkit-transform: scale(0.82)!important;
    transform: scale(0.82)!important;
  } 
  ion-card.dense ion-label {
    font-size: 0.75em;
  }
  ion-card.dense form ion-item ion-input {
    --min-height: unset;
  } 
  ion-card.dense form ion-item ion-input :deep(input) {
    padding: 0!important;
    --min-height: unset;
  } 
  ion-card.dense :deep(ion-card-header) ion-item {
    min-height: 0;
    height: 20px;
  }
  ion-card.dense :deep(ion-card-header) ion-item::part(native) {
    min-height: 0!important;
  }

  ion-card.dense :deep(ion-card-header) .item-inner {
    padding: 0!important;
  }
  ion-card.dense :deep(ion-card-header) ion-icon {
    margin: 0;
  }
  .dark ion-input, .dark ion-select, .dark ion-textarea {
    color: white!important;
    -webkit-text-fill-color: white!important;
    opacity: 1!important; /* required on iOS */
  }

  .span-divider {
    font-size: 1em;
    font-weight: 700!important;
    color: grey!important;
  }
  
  .dark ion-datetime {
    color: white!important;
    -webkit-text-fill-color: white!important;
    opacity: 1!important; /* required on iOS */
  }

  .item-interactive-disabled ion-label, .item-interactive-disabled ion-select { 
    opacity: 0.7!important;
  }
  
</style>
